import { useQuery } from 'react-query';

import { useApi } from '@/lib/api';
import { computeGeometryAreaIdOrStageId } from '@/lib/api/queries/utils';
import { useLocale } from '@/lib/contexts';

interface ActivityReportUnitCategoryProps {
  workspaceId: string;
  geometry?: string;
  areaId?: string;
  filters?: Record<string, any>;
  classification: string;
  period?: ('WEEKS' | 'MONTHS')[];
  lastPeriodIncludes?: string;
  enabled?: boolean;
}

export function useArSoldNewbuildsUnitMixContainedTable({
  workspaceId,
  filters,
  geometry,
  classification,
  areaId,
  period,
  lastPeriodIncludes,
  enabled,
}: ActivityReportUnitCategoryProps) {
  const { api } = useApi();
  const { locale } = useLocale();

  return useQuery(
    [
      'activity-reports-sold-newbuilds-unit-mix-contained-table',
      workspaceId,
      locale,
      filters,
      geometry,
      classification,
      areaId,
      period,
      enabled,
      lastPeriodIncludes,
    ],
    async () =>
      typeof workspaceId === 'string'
        ? api.geodata.chartSources.activityReportsSoldNewbuildsUnitMixContainedTable(
            workspaceId,
            {
              ...filters,
              ...computeGeometryAreaIdOrStageId(geometry, areaId),
              classification: classification,
              period: period,
              last_period_includes: lastPeriodIncludes,
            }
          )
        : undefined,
    {
      enabled:
        enabled &&
        !!workspaceId &&
        !!period &&
        !!computeGeometryAreaIdOrStageId(geometry, areaId),
      //These are mandatory params by the endpoint
    }
  );
}
